import { useGraphQLQuery } from '@betterment/js-runtime';
import { ErrorBoundary, useFeatureFlag } from '@betterment/shared-components';
import { NavLink } from 'react-router-dom';

import { SidebarFeaturesDocument } from './graphql/query.sidebarFeatures.generated';

import { Nav } from '../../../Shared/components-v2/nav/nav';
import { navItemStyles } from '../../../Shared/components-v2/nav/nav-link-styles';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { useProcessNavTransition } from '../../hooks/useProcessNavTransition';

const RedirectNavLinksView: React.FC = () => {
  const processNavTransition = useProcessNavTransition();

  const { enabled: isActivityRefreshFeatureFlagEnabled } = useFeatureFlag({
    splitName: 'retail.activity_refresh_q1_2025_enabled',
    context: 'ActivityLinkSideBar',
  });

  const { enabled: isEnvelopesExperienceEnabled } = useFeatureFlag({
    splitName: 'retail.envelopes_experience_q1_2025_enabled',
    context: 'ActivityLinkSideBar',
  });

  const { data } = useGraphQLQuery(SidebarFeaturesDocument, {
    fetchPolicy: 'cache-first',
  });

  const shouldShowRewardsLink = data?.isEarnedRewardsEligible || data?.isEligibleRewardsEligible;
  const hasPremiumOnboardingOption = !!data?.premiumOnboardingOption;

  return (
    <>
      <NavLink to="/performance" className={navItemStyles()} onClick={processNavTransition}>
        <Nav.Icon name="Bar" />
        <Nav.Text>Performance</Nav.Text>
      </NavLink>
      {isActivityRefreshFeatureFlagEnabled && isEnvelopesExperienceEnabled ? (
        <NavLink to="/activity" className={navItemStyles()} onClick={processNavTransition}>
          <Nav.Icon name="List" />
          <Nav.Text>Activity</Nav.Text>
        </NavLink>
      ) : (
        <NavLink
          to="/activity_transactions"
          className={navItemStyles()}
          reloadDocument={true}
          onClick={processNavTransition}
        >
          <Nav.Icon name="List" />
          <Nav.Text>Activity</Nav.Text>
        </NavLink>
      )}
      <NavLink to="/transfers/new_transfer" className={navItemStyles()} onClick={processNavTransition}>
        <Nav.Icon name="Transfer" />
        <Nav.Text>Transfers</Nav.Text>
      </NavLink>
      <NavLink to="/documents" onClick={processNavTransition} className={navItemStyles()}>
        <Nav.Icon name="Document" />
        <Nav.Text>Documents</Nav.Text>
      </NavLink>

      {(!data?.advisor || shouldShowRewardsLink) && <Nav.Separator />}

      {hasPremiumOnboardingOption && (
        <NavLink
          to="/advice_initiation"
          reloadDocument={true}
          onClick={processNavTransition}
          className={navItemStyles()}
        >
          <Nav.Icon name="Person" />
          <Nav.Text>Talk to an advisor</Nav.Text>
        </NavLink>
      )}

      {shouldShowRewardsLink && (
        <NavLink
          to={data?.isEligibleRewardsEligible ? urlBuilder.appRewards() : urlBuilder.appEarnedRewards()}
          className={navItemStyles()}
          onClick={processNavTransition}
        >
          <Nav.Icon name="Present" />
          <Nav.Text>Earn rewards</Nav.Text>
        </NavLink>
      )}

      <Nav.Separator />
      <NavLink to="/settings" className={navItemStyles()} onClick={processNavTransition}>
        <Nav.Icon name="Gear" />
        <Nav.Text>Settings</Nav.Text>
      </NavLink>
      <NavLink
        to="/login?logout=true"
        rel="nofollow"
        data-method="delete"
        className={navItemStyles()}
        reloadDocument={true}
      >
        <Nav.Icon name="Power" />
        <Nav.Text>Log out</Nav.Text>
      </NavLink>
    </>
  );
};

export const RedirectNavLinks = () => {
  return (
    <ErrorBoundary fallbackType="inline" feature="sidebar" owner="user_engagement">
      <RedirectNavLinksView />
    </ErrorBoundary>
  );
};
